function maskPhone(phone:string):string {
	let subtractedText = phone.substring(phone.length - 4, phone.length)

	return `*******${subtractedText}`
}

export default maskPhone;
